import { applyMiddleware } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import { ownerDetailsReducer } from './reducers/ownerReducers.js'

import {
  userLoginReducer,
  userRegisterReducer,
  userListReducer,
  userDeleteReducer,
  userUpdateReducer,
  userDetailsReducer,
  userProfileReducer,
  userUpdateProfileReducer,
  ownerRegisterReducer
} from './reducers/userReducers.js'

import {
  adminRegisterReducer,
  adminUpdateuserReducer,
  adminGetuserReducer
} from './reducers/adminReducers.js'

import {
  inventoryListReducer,
  inventoryAddReducer,
  inventoryDeleteReducer,
  inventoryUpdateReducer,
  inventoryDetailsReducer,
  inventoryResetReducer,
  inventorySummaryReducer
} from './reducers/inventoryReducers.js'

import {
  itemListReducer,
  itemListAllReducer,
  itemAddReducer,
  itemDeleteReducer,
  itemResetReducer
} from './reducers/itemReducers.js'

import {
  nameListReducer,
  nameAddReducer,
  nameDeleteReducer,
  nameAllReducer,
  nameResetReducer
} from './reducers/nameReducers.js'

import {
  settingAddReducer,
  settingListReducer,
  settingListresetReducer,
  settingUpdateReducer
} from './reducers/settingReducers.js'

import {
  saleListReducer,
  saleListresetReducer,
  generateReceiptReducer,
  returnsReceiptReducer,
  returnedUpdateReducer
} from './reducers/posReducers.js'

import { lowInventoryReducer } from './reducers/reportReducers.js'

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null

const initialState = {
  userLogin: { userInfo: userInfoFromStorage }
}

const middleware = [thunk]

const store = configureStore(
  {
    reducer: {
      userRegister: userRegisterReducer,
      userLogin: userLoginReducer,
      userList: userListReducer,
      userDelete: userDeleteReducer,
      userDetails: userDetailsReducer,
      userUpdate: userUpdateReducer,
      userProfile: userProfileReducer,
      userUpdateProfile: userUpdateProfileReducer,
      ownerDetails: ownerDetailsReducer,
      inventoryList: inventoryListReducer,
      inventoryAdd: inventoryAddReducer,
      inventoryDelete: inventoryDeleteReducer,
      inventoryUpdate: inventoryUpdateReducer,
      inventoryDetails: inventoryDetailsReducer,
      inventoryReset: inventoryResetReducer,
      inventorySummary: inventorySummaryReducer,
      itemList: itemListReducer,
      itemListAll: itemListAllReducer,
      itemAdd: itemAddReducer,
      itemDelete: itemDeleteReducer,
      itemReset: itemResetReducer,
      nameList: nameListReducer,
      nameAdd: nameAddReducer,
      nameDelete: nameDeleteReducer,
      nameAll: nameAllReducer,
      nameReset: nameResetReducer,
      settingAdd: settingAddReducer,
      settingList: settingListReducer,
      settingUpdate: settingUpdateReducer,
      settingListreset: settingListresetReducer,
      saleList: saleListReducer,
      saleListreset: saleListresetReducer,
      returnsReceipt: returnsReceiptReducer,
      returnedUpdate: returnedUpdateReducer,
      lowInventory: lowInventoryReducer,
      generateReceipt: generateReceiptReducer,
      adminRegister: adminRegisterReducer,
      adminUpdateuser: adminUpdateuserReducer,
      adminGetuser: adminGetuserReducer,
      ownerRegister: ownerRegisterReducer
    },
    devTools: process.env.NODE_ENV !== 'production'
  },
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
)

export default store
